<div class="container mx-auto py-8">
  <!-- Greeting and Balance -->
  <div class="mb-8">
    <h2 class="text-3xl text-blue-theme-color font-bold mb-4 capitalize">
      {{ this.greetings | titlecase }}, {{ userName }}
    </h2>
    <div class="flex items-center bg-blue-theme-color rounded-xl p-6 justify-between">
      <div>
        <div class="text-white-color font-semibold text-base mb-2">BALANCE</div>
        <div class="text-white-color text-3xl font-bold">
          {{ this._auth.walletAmount | async }}
        </div>
      </div>
      <button (click)="dialogOpen()" class="bg-[#FF4D23] text-white-color px-6 py-2 rounded-lg font-semibold">
        Add Fund
      </button>
    </div>
  </div>

  <!-- Service Options Grid -->
  <div class="grid md:grid-cols-2 gap-6 mb-8">
    <!-- Standard Package -->

    <div matRipple [routerLink]="'/standard'"
      class="flex items-center h-[140px] bg-white rounded-xl shadow cursor-pointer border border-[#D8DFE7]">
      <img src="assets/images/ui/homestandard.png" class="h-28 sm:mr-4" alt="Standard" />
      <div class="sm:px-5 w-full relative">
        <div class="flex-1">
          <div class="flex items-center justify-between pr-4 sm:pr-0">
            <div class="font-bold text-lg">Standard Package</div>
            <img src="assets/images/ui/rightArrow.svg" class="" />
          </div>
          <div class="text-gray-600 text-sm">
            For lightweight items and packages
          </div>
          <div class="text-[#FF4D23] text-sm font-semibold">
            Max 3 Locations
          </div>
        </div>
      </div>
    </div>

    <!-- Bulk Packages -->
    <div matRipple [routerLink]="'/bulk'"
      class="flex items-center bg-white rounded-xl h-[140px] relative shadow cursor-pointer border border-[#D8DFE7]">
      <img src="assets/images/ui/homeBulk.svg" class="h-28 sm:mr-4" alt="Bulk" />
      <div class="sm:px-5 w-full relative">
        <div class="flex-1">
          <div class="flex items-center justify-between pr-4 sm:pr-0">
            <div class="font-bold text-lg">Bulk Packages</div>
            <img src="assets/images/ui/rightArrow.svg" class="" />
          </div>
          <div class="text-gray-600 text-sm">Fixed Price 4+ Locations</div>
        </div>
      </div>
    </div>

    <!-- Heavy Items & Relocation -->
    <div matRipple [routerLink]="'/standard-heavy'"
      class="flex items-center bg-white rounded-xl h-[140px] relative shadow cursor-pointer border border-[#D8DFE7]">
      <img src="assets/images/ui/heayRelocation.svg" class="h-28 sm:mr-4" alt="Bulk" />
      <div class="sm:px-5 w-full relative">
        <div class="flex-1">
          <div class="flex items-center justify-between pr-4 sm:pr-0">
            <div class="font-bold text-lg">Heavy Items & Relocation</div>
            <img src="assets/images/ui/rightArrow.svg" class="" />
          </div>

          <div class="text-gray-600 text-sm">
            For big loads, relocation, home moves, or carrying heavy stuff
          </div>
        </div>
      </div>
    </div>

    <!-- Inter-Regional -->
    <div matRipple [routerLink]="getInterRegionalRoute()"
      class="flex items-center bg-white h-[140px] rounded-xl relative shadow cursor-pointer border border-[#D8DFE7]">
      <img src="assets/images/ui/interRegional.svg" class="h-28 sm:mr-4" alt="Bulk" />
      <div class="sm:px-5 w-full relative">
        <div class="flex-1">
          <div class="flex items-center justify-between pr-4 sm:pr-0">
            <div class="font-bold text-lg">{{ this.country == "Ghana" ? "Inter-Regional" : "Inter-State" }}</div>
            <img src="assets/images/ui/rightArrow.svg" class="" />
          </div>
          <div class="text-gray-600 text-sm">
            Move packages nationwide, stress free.
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Bottom Banners -->
  <div class="">
    <!-- Discount Banner -->
    <div @showHideUp *ngIf="this.isDiscountBannerShowing && this.discountSlotList?.length" (click)="showAllDiscount()"
      class="flex w-full sm:justify-center">
      <div
        class="bg-[#FFE6ED] rounded-lg px-6 pt-6 flex flex-col justify-between shadow w-full sm:max-w-[518px] relative">
        <div>
          <div class="font-bold text-[#0A2259] text-lg mb-2">
            Unlock Massive Delivery Discounts
          </div>
          <div class="text-gray-700 text-xs mb-4">
            Schedule your deliveries in set time slots <br />
            and enjoy exclusive savings.
          </div>
        </div>
        <button class="bg-[#0A2259] text-white-color  px-4 py-2 rounded-t-md rounded-tl-md font-semibold w-max">
          Learn More!
        </button>
        <img src="assets/images/ui/deliveryDiscount.png" class="w-[90px] bottom-0 right-0 absolute" alt="Closed" />
      </div>
    </div>

    <!-- Delivery Window Closed Banner -->
    <!-- <div
      class="bg-[#FFF6E6] rounded-lg p-6 relative flex flex-col justify-between shadow w-full sm:max-w-[330px]"
    >
      <img
        src="assets/images/ui/deliveryMethod.svg"
        class="w-[90px] absolute bottom-0 right-0"
        alt="Closed"
      />
      <div class="flex items-center mb-2">
        <div>
          <div class="font-bold text-lg text-[#0A2259]">
            Delivery Window Closed
          </div>
          <div class="text-gray-700 text-xs">
            We'll resume at
            <span class="text-[#FF4D23] font-semibold">4:30 PM</span>. You can
            still <br />schedule your delivery now
          </div>
        </div>
      </div>
      <div class="text-gray-600 text-sm">Thank You for your patience!</div>
    </div> -->
  </div>
</div>